import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  loading: {
    opacity: theme.palette.action.disabledOpacity,
    pointerEvents: "none"
  }
}));
